// ----------------------------------------------------------------------

import Settings from 'components/settings';

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  dont_have_an_account: 'Don’t have an account ?',
  hi_welcome_back: 'Hi, Welcome Back',
  sign_in_to: 'Sign in to',
  enter_your_details_below: 'Enter your details below.',
  get_started: 'Get started',
  email_address: 'Email Address',
  address: 'Address',
  new_coming_soon: 'New Gateways are coming soon',
  city: 'City',
  quick_links: 'Quick Links',
  contact_now: 'Contact Now !',
  state: 'State',
  password: 'Password',
  zip: 'Zip',
  forgot_password: 'Forgot password?',
  country: 'Country',
  select_country: 'Select Country',
  login: 'Login',
  email_must_be_a_valid_email_address: 'Invalid email',
  email_is_required: 'Email is required',
  city_is_required: 'City is Required',
  state_is_required: 'State is required',
  zip_is_required: 'Zip is required',
  password_is_required: 'Password is required',
  already_have_an_account: 'Already have an account?',
  create_form: 'Create a form',
  register_with_form_pay_heading:
    'Register with FormPay to get Payments smoothly from your customer.',
  get_started_absolutely_free: 'Get started absolutely free.',
  seven_days_trail_no_credit_card:
    '7 days free trial. No credit card required,',
  by_registering_i_agree_to_formpay: 'By registering, I agree to FormPay',
  terms_of_service: 'Terms of Service',
  and: 'and',
  portal_already_in_use: 'Portal is already in use',
  privacy_policy: 'Privacy policy',
  passwords_must_match: 'Passwords must match',
  resend_verification: 'Resend Verification',
  login_here: 'Login here',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  save_password: 'Save Password',
  invalid_token_verification: 'Invalid Token Verification',
  confirm_new_password: 'Confirm Password',
  forgot_your_password: 'Forgot your password?',
  update_form: 'Update Form',
  publish_form: 'Publish Form',
  please_enter_email_to_get_link:
    'Please enter the email address associated with your account. We will email you a link to reset your password.',
  back_to_login: 'Back to Login',
  password_change_successfully: 'Password changed successfully',
  back_to_register: 'Back to register',
  request_sent_sucessfully: 'Request sent successfully',
  sent_confirmation_to: 'We have sent a confirmation email to',
  please_check_your_email: 'Please check your email.',
  back: 'Back',
  privacy_notice:
    'We’re committed to your privacy. FormPay uses the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information, check out our',
  email_verified_successfully: 'Email Verified Successfully',
  go_to_login: 'Go to Login',
  emailed_a_link_to_verify: 'We have emailed a link to verify your email',
  dont_have_email: 'Don’t have a mail?',
  resend_email: 'Resend email',
  email_not_verified_try_again: 'Email Not Verified Try Again',
  recheck_your_email_or_register_again:
    'There is something wrong please re-click your email link or register again from login.',
  code_is_required: 'Code is required',
  code: 'code',
  comments: 'Comments',
  verify: 'Verify',
  connect: 'Connect to:',
  rzp_test: 'Connect to Razorpay test mode',
  rzp_live: 'Connect to Razorpay live mode',
  verification_link_resent: 'Verification link resent, Please check Mailbox.',
  account_connected: 'Account connected successfully',
  acc_disconnected: 'Account Disconnected',
  error_occurred: 'Some error occurred',
  resend: 'Resend',
  already_connected_to_rzp: 'You are connected to your Razorpay account',
  connected_to_rzp_test: 'You are connected to Razorpay test account',
  fill_connect_to_rzp: 'Fill the details and connect to Razorpay',
  connect_with_rzp_oauth: 'Connect to Razorpay with OAuth',
  fill_all_details_to_connect_rzp:
    'Fill all the details below to connect to Razorpay and make successful payments',
  register: 'Register',
  didnt_gateway: "Didn't find your gateway ?",
  single_document: 'Documentation',
  stripe_and_paypal_to_be_comming_soon:
    'Stripe and Paypal are next gateways to be integrated soon',
  id: 'ID:',
  connect_with_us: 'Still need help? Connect with us',
  need_help: 'Need Help',
  logout: 'Logout',
  connect_portals: 'Connect Portals',
  choose_listed_portals:
    'Choose from any of the listed HubSpot Portals. If your portal is not listed, to create a new portal go to HubSpot',
  add_new_portal: 'Add New Portal',
  no_portal_found: 'No Portal Found',
  no_portal_added_yet_click_add_new_portal_btn:
    'No Portal has been added yet. You can add new portals by clicking on add new portal button',
  portal_listing: 'Portal Listing',
  support: 'Support',
  hubspot_portals: 'Hubspot Portals',
  mailed_six_digit_code:
    'We have emailed a 6-digit confirmation code to acb@domain, please enter the code in below box to verify your email.',
  resend_code: 'Resend code',
  your_dashboard: 'Your Dashboard',
  overview: 'Overview',
  total_order: 'Total Order',
  total_revenue: 'Total Revenue',
  revenue: 'Revenue',
  last_week: 'than last week',
  average_order_value: 'Average Order Value',
  total_payment_forms: 'Total Payment forms',
  core_product_sold: 'Core Product Sold',
  upsell_sold: 'Upsell Sold',
  revenue_monthly: 'Monthly Transactions and Revenue',
  filter_by_date: 'Filter by Date Range',
  monthly_yearly_users: 'Monthly + Year Active User',
  invoice_id: 'Invoice ID',
  category: 'Category',
  price: 'Price',
  active: 'Active',
  inActive: 'In-active',
  connect_Xero: 'Connect to Xero',
  connect_Xero_single_click: 'Connect to Xero with a single click',
  dashboard: 'Dashboard',
  tutorial: 'Tutorial',
  schedule_meeting:
    'Schedule a 1-on-1 meeting with our implementation expert to help you integrate Formpay',
  schedule_now: 'Schedule Now',
  active_gateways: 'Active Gateways',
  welcome: 'Welcome',
  name: 'Name',
  created: 'Created At',
  type: 'Type',
  action: 'Action',
  form_listing: 'Form Listing',
  forms: 'Forms',
  form: 'Form',
  form_list: 'Form List',
  createp: 'Create',
  create_new_form: 'Create New Form',
  create_new_quote: 'Create New Quote',
  name_is_required: 'Name is required',
  country_is_required: 'Country is required',
  amount_does_not_match_with_plan:
    'Amount does not match with the selected plan.',
  phone_number_not_valid: 'Phone Number Not Valid',
  valid_url: 'Valid url',
  hubspot_form_is_required: 'HubSpot Form is required',
  mode_is_required: 'Mode is required',
  fill_valid_amount: 'Fill Valid Amount',
  select_currency: 'Select Currency',
  payment_type_is_required: 'Payment Type is required',
  select_atleast_one_gateway: 'Select at least 1 Gateway',
  edit: 'Edit',
  editp: 'Edit Product',
  form_settings: 'Form Settings',
  payment_settings: 'Payment Settings',
  payment_method: 'Payment Method',
  delete_form: 'Delete Form',
  delete_product: 'Delete Product',
  publish_the_form_to_load_preview: 'Please publish the form to load preview',
  please_fix_errors: 'Please Fix Errors.',
  form_name: 'Form Name',
  select_hubspot_form: 'Select Hubspot Form',
  enter_amount: 'Enter Amount',
  recent_transactions: 'Recent Transactions',
  single: 'Single',
  enable_test_mode: 'Enable Test Mode',
  update_quote: 'Update Quote',
  create_quote: 'Create Quote',
  no_gateway_found: 'No gateway found',
  currency: 'Currency',
  form_submission: 'Submissions',
  form_submission_listing: 'Submissions Listing',
  view_in_hubspot: 'View in HubSpot',
  status: 'Status',
  view_all: 'View All',
  none: 'None',
  date: 'Date',
  amount: 'Amount',
  transaction: 'Transaction',
  transaction_listing: 'Transaction Listing',
  success: 'Success',
  failed: 'Failed',
  payment_gateway: 'Payment Gateway',
  gateways: 'Gateways',
  manage: 'Manage',
  setup: 'Setup',
  new_invoice: 'New Invoice',
  gatway_listing: 'Gateway Listing',
  setup_instructions: 'Setup Instructions',
  test_merchant_id_is_required: 'Test Merchant Id is required',
  test_store_id_is_required: 'Test Store Id is required',
  test_public_key_is_required: 'Test Public key Id is required',
  test_private_key_file_is_required: 'Test Private Key File is required',
  live_merchant_id_is_required: 'Live Merchant Id is required',
  live_store_id_is_required: 'Live Store Id is required',
  live_public_key_id_is_required: 'Live Public key Id is required',
  live_private_key_file_is_required: 'Live Private Key File is required',
  payment_region_is_required: 'Payment Region is required',
  payment_currency_is_required: 'Payment Currency is required',
  button_language_is_required: 'Button Language is required',
  button_color_is_required: 'Button Color is required',
  product_type_is_required: 'Product Type is required',
  test_account_details: 'Test Account Details',
  merchant_id: 'Merchant Id',
  account_single: 'Account',
  store_id: 'Store Id',
  public_key_id: 'Public Key Id',
  page_will_open_in: 'Page will open in',
  test_private_key_file: 'Test Private Key File',
  live_account_details: 'Live Account Details',
  live_private_key_file: 'Live Private key File',
  other_account_details: 'Other Account Details',
  payment_region: 'Payment Region',
  payment_currency: 'Payment Currency',
  button_language: 'Button Language',
  button_color: 'Button Color',
  product_type: 'Product Type',
  activate_gateway: 'Activate Gateway',
  test_api_key_is_required: 'Test Api Key is required',
  test_merchant_account_is_required: 'Test Merchant Account is required',
  test_client_key_is_required: 'Test Client Key is required',
  live_api_key_is_required: 'Live Api Key is required',
  live_merchant_account_name_is_required:
    'Live Merchant Account Name is required',
  live_client_key_is_required: 'Live Client Key is required',
  live_end_point_prefix_is_required: 'Live Endpoint Prefix is required',
  test_api_key: 'Test Api Key',
  test_merchant_account_name: 'Test Merchant Account Name',
  test_client_key: 'Test Client Key',
  live_api_key: 'Live Api Key',
  live_merchant_account_name: 'Live Merchant Account Name',
  live_client_key: 'Live Client Key',
  live_endpoint_prefix: 'Live Endpoint Prefix',
  issue_payment_failed: 'There was an issue! Payment Failed.',
  payment_successful_redirect_to_dashboard:
    'Payment Successful.Redirecting to Accounts Billing...',
  payment: 'Payment',
  billing_details: 'Billing Details',
  full_name: 'Full Name',
  phone: 'Phone',
  payment_info: 'Payment Info',
  plan: 'Plan',
  month: 'Month',
  today: 'Today',
  this_week: 'This Week',
  this_month: 'This Month',
  this_year: 'This Year',
  year: 'Year',
  transactions_and_revenue: 'Transactions and Revenue',
  filter: 'Filter',
  average_revenue: 'Average Revenue',
  total_form_submissions: 'Total Form Submissions',
  total_revenue_all: 'Total Revenue(All time)',
  saving_per_month: 'Saving $24 a month',
  order_summary: 'Order Summary',
  sub_total: 'Sub Total',
  total: 'Total',
  complete_payment: 'Complete Payment',
  plan_subscribed: 'Plan Subscribed',
  you_have_been_subscribed_to: 'You have been Subscribed to',
  your_subscription_will_end_on: 'your subscription will end on',
  your_next_payment_date_is: 'Your Next Payment Due Date is',
  cancel_subscription: 'Cancel Subscription',
  something_went_wrong_contact_admin:
    'Something went wrong.Please get in touch with Administrator',
  delete: 'Delete',
  next: 'Next',
  change_password: 'Change password',
  integrations: 'Integrations',
  disconnect_xero_confirmation_notice:
    'The taken action will disconnect your Xero account and you will no longer be able to access it untill you connect it.',
  sure_disc_xero: 'Are you sure you want to disconnect?',
  disconnect_xero: 'Disconnect Xero',
  connected_to_xero: 'You are connected to Xero',
  disconnect: 'Disconnect',
  set_password: 'Set password',
  your_new_password_different_from_prev_password:
    'Your new password must be different from previously used passwords. Must contain at least 8 characters.',
  your_password_conatain_characters:
    'Your Password must contain at least 8 characters',
  back_to_dashboard: 'Back To Dashboard',
  manage_hubspot_form: 'Manage Hubspot Form',
  sorry_page_not_found: 'Sorry, page not found!',
  sorry_could_not_find_page:
    "Sorry, we couldn't find the page you're looking for. Maybe you mistyped the URL? Be sure to check your spelling.",
  go_to_home: 'Go to Home',
  email_format_incorrect: 'Email format is incorrect.',
  first_name: 'First Name',
  payment_type: 'Payment Type',
  form_not_showing: "don't see your form?",
  email_captcha_mandatory:
    'Email field is mandatory and captcha should be disabled in Hubspot Form.',
  no_hubspot_products_in_your_portal: 'No Hubspot Products in your portal',
  pay_button_description:
    'This will show a pay button instead of the form and show the form in the modal on the click of the pay button',
  last_name: 'Last Name',
  transaction_Details: 'Transaction Details',
  transactions: 'Transactions',
  phone_number: 'Phone Number',
  state_region: 'State/Region',
  save_details: 'Save Details',
  your_form_is_published: 'Your form is published',
  form_preview: 'Form Preview',
  embed_code: 'Embed Code',
  add_your_hubspot_portal: 'Add your HubSpot Portal(s) to the app',
  select_the_portal_you_want_to_connect:
    'Select the portal you want to connect',
  setup_payment_gateways: 'Setup payment gateways',
  create_configure_forms: 'Create, Configure and Publish the form(s)',
  comming_soon: 'Coming Soon',
  No_appropriate_forms_found_in_portal: 'No appropriate forms found in portal',
  page_not_found: '404 Page Not Found',
  billing: 'billing',
  user_accounts: 'User Accounts',
  ecommerce: `e-commerce`,
  product_list: 'Product List',
  product_price: 'Product Price',
  reset_password: 'Reset Password',
  send_mail: 'Send Email',
  create_a_form_and_select:
    'Let us create a form for you or select a form from the below list',
  connect_with_hubspot:
    'Connect your HubSpot Account so we can connect with your portal',
  create_a_form: 'Create a form for me',
  connect_my_hubspot_account: 'Connect My Hubspot Account',
  skip_this_step: 'Skip this step',
  connect_with_hubspot_account: 'Connect your Hubspot Account',
  fill_the_required_fields: 'Fill the required Fields',
  old_password_is_required: 'Old Password is required',
  password_must_be_eight_char: 'Password must be at least 8 characters',
  new_password_is_required: 'New Password is required',
  save: 'Save',
  old_password: 'Old Password',
  first_name_is_required: 'First Name is required',
  last_name_is_required: 'Last Name is required',
  phone_must_contain_10_digit: 'Phone Number must contain 10 digits',
  address_is_required: 'Address is required',
  zipcode_is_required: 'Zipcode is required',
  no: 'No',
  has_been_found_yet: 'has been found yet',
  will_expire_today: 'will expire Today.',
  will_expire_on: 'will expire on',
  your_plan: 'Your Plan',
  test_client_id: 'Test Client ID',
  live_client_id: 'Live Client ID',
  button_layout: 'Button Layout',
  button_shape: 'Button Shape',
  button_label: 'Button Label',
  live_client_id_is_required: 'Live Client Id is required.',
  test_client_id_is_required: 'Test Client Id is required.',
  button_layout_is_required: 'Button Layout is required.',
  button_shape_is_required: 'Button Shape is required.',
  button_label_is_required: 'Button Label is required.',
  test_publishable_key_is_required: 'Test Publishable Key is required',
  test_publishable_key: 'Test Publishable Key',
  test_secret_key_is_required: 'Test Secret Key is required',
  test_secret_key: 'Test Secret key',
  live_publishable_key_is_required: 'Live Publishable Key is required',
  live_publishable_key: 'Live Publishable Key',
  live_secret_key_is_required: 'Live Secret Key is required',
  live_secret_key: 'Live Secret key',
  feel_free_to_contact_us_anytime: 'Feel free to contact us anytime',
  general: `general`,
  your_trial: 'Your Trial',
  allow_custom_amount: 'Allow Custom Amount',
  donation_form_settings: 'Donation Form Settings',
  donation_form: 'Donation Form',
  enter_title: 'Enter Title',
  enter_description: 'Enter Description',
  title: 'Title',
  logo: 'Logo',
  suggested_amount: 'Suggested Amount',
  transaction_cost_settings: 'Transaction Cost Settings',
  add_transaction_cost: 'Add Transaction Cost',
  transaction_cost_type: 'Transaction Cost Type',
  base_amount: 'Base Amount',
  unit_amount: 'Unit Amount',
  fixed: 'Fixed',
  variable: 'Variable',
  should_be_greater_than: 'Should be greater than',
  is_required: 'is required',
  redirection_setting: 'Redirection Settings',
  redirect_url: 'Redirect Url',
  allow_redirection: 'Allow Redirection',
  transaction_amount: 'Transaction Amount',
  app: `app`,
  user: `user`,
  list: `list`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `Description`,
  description_is_required: `Description is required`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  you_have_only: 'You have only',
  quotes: 'Quotes',
  left_in_trial: 'days left of your trial period',
  set_login_password: 'Please set your password to log in,',
  click: 'Click Here',
  to_send_mail: 'to send mail.',
  update: 'Update',
  one_currency_gateway:
    'You can select payment gateways with one currency type',
  theme: 'Theme',
  transaction_cost_label: 'Transaction Cost Label',
  thank_you_page_settings: 'Thank You Page Setting',
  thank_you_title: 'Title',
  thank_you_subtitle: 'Sub Title',
  thank_you_description: 'Description',
  image: 'Image',
  show_hide_in_memory_of: 'Show/Hide in Memory Of',
  donation_memory_label: 'Donation Memory Label',
  custom_amount: 'Custom Amount',
  donate_button_text: 'Donate Button Text',
  donate_button_color: 'Donate Button Color',
  back_button_text: 'Back Button Text',
  back_button_color: 'Back Button Color',
  theme_color: 'Theme Color',
  theme_settings: 'Theme Settings',
  theme_color_is_required: 'Theme Color is required',
  back_button_link: 'Back Button Link',
  for_every: 'For every',
  will_be_charged: 'will be charged',
  charge: 'Charge',
  per: 'per',
  upload: 'upload',
  bucks: 'bucks',
  reference_id: 'Reference Id',
  reference_id_copy: 'Reference Id (Click to copy)',
  products_purchased: 'Products purchased',
  products_quantity: 'Product x Quantity',
  thank_you_image: 'Thank you image',
  share_url: 'Share Url',
  enter_valid: 'Enter valid',
  should_contain_http: '(Should contain HTTP/HTTPS)',
  your_quote_is_published: 'Your quote is published',
  prefer_multiple_3: 'Prefer 3 or 6 to match the design',
  in: 'in',
  test_mode: 'test mode',
  live_mode: 'live mode',
  transaction_unit_amount: 'Transaction unit amount',
  transaction_cost_variable_base_amount:
    'Transaction cost variable base amount',
  enter_amount_press_enter: 'Enter amount and press enter',
  need_help_success: 'Need Help? Continue with our',
  success_manager: 'Success Manager',
  how_would_you_continue: 'How would you like to continue?',
  go_setup_instructions: 'Go on Yourself with the Setup Instructions',
  portal_already_connected_description: `This portal has already been connected to another account. Please
  login with the connected account or connect another HubSpot portal.`,
  portal_already_connected: 'Portal already connected',
  questions_or_concerns: ` If you have any questions or concerns about this, please contact us
  at`,
  enter_email: 'Enter your email',
  pay_button: 'Show Pay Button',
  test_key_id_required: 'Test Key Id is required',
  test_key_secret_required: 'Test Key secret is required',
  live_key_secret_required: 'Live Key secret is required',
  live_key_id_required: 'Live Key id is required',
  test_key_id: 'Test Key Id',
  test_key_secret: 'Test Key secret',
  live_key_id: 'Live Key Id',
  live_key_secret: 'Live Key secret',
  Select_default_gateway: 'Select default gateway',
  fill_either_live_or_test_or_both:
    'Fill live and test both or either of them to activate gateway',
  image_url: 'Image Url',
  products: 'Products',
  draggable: 'Products are draggable.',
  enable: 'to enable.',
  product_settings: 'Product Settings',
  add_product: 'Add new product',
  image_valid_url: 'Enter valid Image URL',
  other_details: 'Other Details',
  payment_method_settings: 'Payment method settings',
  select_gateways_to_see_settings:
    'Select gateways to see gateway-specific settings',
  select_razorpay_plan: 'Select Razorpay plan',
  custom_amount_disabled: 'Custom amount is disabled, delete the',
  user_onboarded: 'User already onboarded, kindly login to continue.',
  enable_subscription: 'Enable Subscription',
  subscription_enabled_notice:
    'Settings unavailable when Subscription is enabled',
  pay_button_text: 'Pay Button Text',
  pay_button_text_required: 'Pay button text is required',
  image_url_required: 'Image URL is required',
  select_default_gateway: 'Select default gateway',
  default_gateway: 'Default Gateway',
  default_gateway_tooltip_description:
    'Setting default gateways allows payment method to open by default ( example: card fields will open automatically), Not all gateways support this field',
  no_settings_available: 'No settings are available for selected gateway',
  success_manager_description:
    'Success manager will get in touch with you instantly, and help you deal with all the onboarding challenges perfectly.',
  self_setup_instructions_description:
    'Continue on your and set up the form with instructions given in the dashboard',
  styles: 'Styles',
  style_settings: 'Style Settings',
  hover_over_fields:
    'Hover over the fields on the preview form on right to edit the text',
  create_product: 'Create Product',
  product_id: 'Product Id',
  product_name: 'Product Name',
  product_name_required: 'Product name is required field.',
  product_description_required: 'Product description is required field.',
  product_price_required: 'Product price is required field.',
  hubspot_id_required: 'Hubspot ID is required field.',
  product_image: 'Product Image',
  product_description: 'Product Description',
  hubspot_product_id: 'Hubspot Product Id',
  portal_id: 'Portal Id',
  select_product: 'Select Product',
  hs_product_id: 'Hubspot Product Id ',
  hs_product_id_required: 'Hubspot Product Id required.',
  only_numbers: 'Please Enter Only Numbers',
  rows_per_page: 'Rows Per Page',
  of: 'of',
  rows: 'Rows',
  agree: 'Agree',
  disAgree: 'Disagree',
  yes: 'Yes',
  coupons: 'Coupons',
  create_coupon: 'Create Coupon',
  coupon_id: 'Coupon ID',
  autogenerate_coupons_exist:
    'Autogenerated Coupons do not exist in the database and are valid',
  select_discount_type: 'Select Discount Type',
  discount_type_value: 'Discount Type Value',
  apply_to_specific_product: 'Apply To Specific Product',
  limit_per_customer: 'Limit Per Customer',
  coupon_description: 'Coupon Description',
  coupon_expiring_date: 'Coupon Expiring Date',
  select_form: 'Select Form',
  customers_email: 'Customers Email',
  minimum_amount: 'Minimum Amount',
  if_you_do_not_select_any_product:
    'If you do not select any product, in that case, coupon would be applicable on all products.',
  if_you_do_not_select_any_form:
    'If you do not select any Form, in that case, coupon would be applicable on all forms.',
  if_you_do_not_select_any_limit:
    'If you do not Enter any limit, the same customer can apply the same coupon for unlimited times',
  enter_the_value: 'Enter the value',
  coupon_code: 'Coupon Code',
  coupon_type: 'Coupon Type',
  allowed_customer: 'Allowed Customers',
  no_forms_available: 'No Forms Available',
  form_type: 'Form Type',
  allowed_forms: 'Allowed Forms',
  discount_value: 'Discount Value',
  no_records_found: 'No Records Found',
  expire_date: 'Expire Date',
  if_you_do_not_enter_any_email:
    'If you do not enter any email, in that case, coupon would be valid for all customers.',
  if_you_do_not_set_expiry:
    'If you do not set an expiry date , in that case, coupon would be valid for infinite time.',
  coupon_settings: 'Coupon Settings',
  allow_coupons: 'Allow Coupons',
  applied_coupons_are: 'Applied coupons are Listed below.',
  edit_product: 'Edit Your Product Here',
  upload_image: 'Upload Image',
  submit: 'Submit',
  create_your_product: 'Create Your Product Here',
  no_product_found: 'No Product Found!',
  no_coupon_found: 'No Coupon Found!',
  if_donation_is_allowed_then:
    'If the donation is allowed, in that case, Coupons can not be allowed.',
  enter_email_and_press_enter: 'Enter Email and Press Enter',
  please_enter_correct_email: 'Please enter correct email',
  coupon_must_be_in_uppercase:
    'Coupon must be in UpperCase having Numbers and Alphabets',
  coupon_code_at_least_have: 'Coupon code at least have 6 characters',
  coupon_code_at_most_have: 'Coupon code at most have 20 characters',
  amount_must_be: 'Amount must be between 1 to 100',
  amount_must_be_greater: 'Amount must be greater than 1.',
  amount_must_be_less: 'Amount must be less than 100.',
  limit_must_be_greater_or: 'Limit must be greater than 1.',
  limit_min: 'Limit should be greater than 1.',
  limit_max: 'Limit should be less than 9999.',
  minimum_amount_should_be:
    'Minimum Amount must be greater than or equal to zero.',
  minimum_amount_min: 'Minimum Amount must be greater than zero',
  minimum_amount_max: 'Minimum Amount must be less than 9999',
  amount_flat_min: 'Amount must be greater than 1.',
  amount_flat_max: 'Amount must be less than 9999.',
  amount_flat_between: 'Amount must be between 1 to 9999',
  subscription_cancelled: 'Subscription Cancelled',
  cancel: 'Cancel',
  discount: 'Discount',
  you_can_only_edit_coupon_description:
    'You can only edit coupon description , once Coupon is used.',
  no_quotes_found: 'No Quotes Found',
  product_name_at_least_have: 'Product name at least have 3 characters',
  product_description_at_least_have:
    'Product description at least have 6 characters',
  product_name_at_most_have: 'Product name at most 100 characters',
  product_description_at_most_have:
    'Product description at most have 20 characters',
  max_product_price: 'Product price should not exceed 999999',
  change_the_toggle:
    'To set Expiry date check the toggle and select the date, otherwise coupon would never expire.',
  change_the_toggle_for_limit:
    'To set Coupon Limit check the toggle and enter the limit, otherwise same coupon can be used unlimited times.',
  delete_all_products: 'Delete all products , to allow Donation.',
  min_product_price: 'Product price should not less than 1.',
  subscription: 'Subscription',
  enable_subscription_description:
    'If subscription is enabled then it would be subscribe on monthly basis',
  stripe_settings: 'Stripe Settings',
  allow_recurring: 'Allow Recurring',
  allow_recurring_is_enabled:
    'If Recurring is allowed , then subscription would be created for donation form.',
  recurring_can_be_allowed:
    'Recurring can be allowed only with stripe, please select stripe.',
  surety_notice: 'Are you sure of the action taken?',
  disable_recurring_notice:
    'Disabling this setting will disable the recurring donation setting as well.',
  enable_recurring_notice:
    'Enabling this setting will enable the recurring donation setting as well.',
  continue: 'Continue',
  disable_subscription_notice:
    'Disabling this setting will disable the subscription setting as well.',
  enable_subscription_notice:
    'Enabling this setting will enable the subscription setting as well.',
  select_stipe_to_enable_subscription:
    'To enable subscription you must select stripe as gateway',
  subscription_settings: 'Subscription settings',
  allow_donation_to_enable_subscription:
    'To enable subscription you must allow donation',
  allow_custom_product: 'Allow Custom product',
  custom_product_info_to_sell:
    'If custom product is allowed , then formpay products cannot be added.',
  custom_product_settings: 'Custom Product Settings',
  product_display_setting: 'Product Display Settings',
  if_custom_product_is_enable:
    'If custom Product is enable , products added here would be of no use.',
  if_custom_product_is_allowed:
    'If custom product is allowed , then donation can not be allowed.',
  subscription_listing: 'Subscription Listing',
  user_mail: 'Customer Email',
  billing_cycle: 'Billing Cycle',
  mode: 'Mode',
  info: 'Info',
  subscription_details: 'Subscription Details',
  subs_id: 'Subscription ID',
  search_transactions: 'Search for transactions',
  Scard: 'Stripe Card',
  Stripe_Session: 'Stripe Session',
  e_wallet_setting: 'e-Wallet Setting',
  enable_apple_gpay_link: 'Enable Apple Pay, Google Pay & LinkPay',
  enable_deal: 'Enable Deal',
  select_single: 'Select Single Product',
  sub_start: 'Subscription Start Date',
  sub_duration: 'Subscription Duration',
  sub_next: 'Next Payment Date',
  details_raw: 'Raw Details',
  allow_only_recurring: 'Allow only recurring payments',
};

export default en;
